import React, { useState, useEffect, useRef } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { DateRangePicker } from 'rsuite';
import { format } from 'date-fns';
import CustomerSuggestionBox from '../CommonComp/CustomerSuggestionBox';
import ViewCustomer from "../Master/ViewCustomer"

const SalesList = () => {
    const accessToken = localStorage.getItem('accessToken');
    const [reportrange, setReportrange] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchValue, setSearchValue] = useState([]);
    const [selectedType, setSelectedType] = useState('all');
    const [searchSupplier, setSearchSupplier] = useState('');
    const [purchaseLedgerList, setPurchaseLedgerList] = useState([]);
    const salesLedgerRef = useRef(null);
    const [customer, setCustomer] = useState(null); 
    

    const handleCustomerChange = (selectedCustomer) => {
        setCustomer(selectedCustomer);
    };


    const handleDateChange = (dates) => {
        if (dates && dates.length === 2) {
            const [start, end] = dates;
            setFromDate(format(start, 'yyyy-MM-dd'));
            setToDate(format(end, 'yyyy-MM-dd'));
            setReportrange(`${format(start, 'MM/dd/yyyy')} - ${format(end, 'MM/dd/yyyy')}`);
        } else if (!dates) {
            // Handle clearing the dates
            setFromDate('');
            setToDate('');
            setReportrange('');
        }
    };

    const getSalesLedgerList = () => {
        const $table = $(salesLedgerRef.current);
        if ($.fn.DataTable.isDataTable($table)) {
            $table.DataTable().destroy();
        }
        let i = 0;
        $table.DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: `${config.api_url}/ws-sales-ledger`,
                type: 'POST',
                headers: {
                authorization : `Bearer ${accessToken}`,
                },
                data: function (d) {
                    return $.extend({}, d, {
                        draw: d.draw,
                        start: d.start,
                        length: d.length,
                        searchValue: searchValue,
                        selectedType: selectedType,
                        customer: customer?.value || null,
                        fromDate: fromDate,
                        toDate: toDate
                    });
                },
                dataSrc: function (json) {
                    return Array.isArray(json.data) ? json.data : [];
                }
            },
            language: {
                paginate: {
                    first: 'First',
                    last: 'Last',
                    next: 'Next',
                    previous: 'Previous',
                },
                search: 'Search:',
            },
            columns: [
                { data: 'date' },
                { data: 'type' },
                
                {
                    data: 'job_ref',
                    className: 'sales-ledger-col-jobref',
                    render: function(data) {
                        const value = data || '';
                        const esc = String(value)
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;');
                        return `<div class="sales-ledger-cell-clip" title="${esc}">${esc}</div>`;
                    }
                },
                { 
                    data: null,
                    render : function(data, type, row){
                        return `<a href="/DeliveryInvView/${row.sales_ledger_id}" ><sapn>${row.reference_no}</sapn></a>`;
                    }
                },
                { 
                    data: null,
                    className: 'sales-ledger-col-customer',
                    render: function(data, type, row) {
                        const customerName = row.company_name || '';
                        const id = row.customer_id != null ? String(row.customer_id) : '';
                        const fullRaw = `${customerName} (${id})`;
                        const fullEsc = fullRaw
                            .replace(/&/g, '&amp;')
                            .replace(/</g, '&lt;')
                            .replace(/>/g, '&gt;')
                            .replace(/"/g, '&quot;');
                        return `<a class="viewbtn sales-ledger-customer-link" href="#" data-id="${row.customer_id}" data-bs-toggle="modal" data-bs-target="#view_customer" title="${fullEsc}">
                                    <span class="sales-ledger-customer-text">${fullEsc}</span>
                                </a>`;
                    }
                },
                { data: 'value', className: 'sales-ledger-col-num text-end' },
                { data: 'balance', className: 'sales-ledger-col-num text-end' },
                { data: 'status' },
                { 
                    data: null,
                    render: function(data, type, row) {
                        const isClosed = String(row.status || '').toLowerCase() === 'close';
                        if (isClosed) {
                            return '';
                        }
                        return `<a href="/ReceivePaymentEdit/${row.sales_ledger_id}">Pay</a>`;
                    }
                },
            ],
            columnDefs: [
            {
                orderable: false, 
                targets: '_all'
            },
        ],
            pageLength: 10,
        });

    };

    useEffect(() => {
        /*if (accessToken === null) {
            window.location.href = '/login';
            return;
        }*/

        getSalesLedgerList();

        return () => {
            if (salesLedgerRef.current && $.fn.DataTable.isDataTable(salesLedgerRef.current)) {
                $(salesLedgerRef.current).DataTable().destroy();
            }
           
        };

    }, [searchValue, selectedType, fromDate, toDate, customer]);

    /*const fetchData = async () => {
        const accessToken = localStorage.getItem('accessToken');

        if (!accessToken) {
            window.location.href = '/login';
            return;
        }

        const formData = new FormData();
        formData.append('searchByFromdate', fromDate);
        formData.append('searchByTodate', toDate);
        formData.append('draw', draw);
        formData.append('start', start);
        formData.append('length', length);
        formData.append('searchValue', selectedRole);

        const apiUrl = `${config.api_url}/ws-purchase-ledger`;
        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    authorization: `Bearer ${accessToken}`,
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Failed to fetch purchase data');
            }

            const data = await response.json();
            setPurchaseLedgerList(data.purchase_ledger);

        } catch (error) {
            console.error('Error fetching purchase data:', error);
        }
    };


    useEffect(() => {
        fetchData();
    }, [fromDate, toDate, selectedRole]);*/

    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12"> <a href="#"><i className="fa fa-home"></i></a> &gt; <a href="/Dashboard">Dashboard</a> &gt; <span className="last-crumb">Sales List</span> </div>
                    </div>
                </div>
            </div>
            <ViewCustomer />
            <div className="main-container">
                <form id='new_sales_order'>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 col-lg-12 col-sm-12">
                                <div className="show-order-area dashboard">
                                    <div className="dashform">
                                        <div className="topsearch-area purchase-list-filters">
                                            <div className="purchase-list-filters-row">
                                                <div className="purchase-list-filter-item purchase-list-filter-search">
                                                    <label htmlFor="product_name" className="col-form-label">
                                                        S.O ID/Customer/Cust ID
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="search-area form-control"
                                                        placeholder="Search"
                                                        name="product_name"
                                                        id="product_name"
                                                        onChange={(e) => setSearchValue(e.target.value)}
                                                    />
                                                </div>
                                                <div className="purchase-list-filter-item purchase-list-filter-type">
                                                    <label htmlFor="warehouse_id" className="col-form-label">Status</label>
                                                    <select
                                                        name="warehouse_id"
                                                        id="warehouse_id"
                                                        className="form-select"
                                                        value={selectedType}
                                                        onChange={(e) => setSelectedType(e.target.value)}
                                                    >
                                                        <option value="all">All</option>
                                                        <option value="inv">INV</option>
                                                        <option value="credit">Credit</option>
                                                    </select>
                                                </div>
                                                <div className="purchase-list-filter-item purchase-list-filter-supplier">
                                                    <label className="col-form-label">Customer Name</label>
                                                    <CustomerSuggestionBox
                                                        onCustomerChange={handleCustomerChange}
                                                        placeholder="Select Customer"
                                                    />
                                                </div>
                                                <div className="purchase-list-filter-item purchase-list-filter-daterange">
                                                    <label htmlFor="sales-list-daterange" className="col-form-label">
                                                        Date Range
                                                    </label>
                                                    <DateRangePicker
                                                        id="sales-list-daterange"
                                                        value={[
                                                            fromDate ? new Date(fromDate) : undefined,
                                                            toDate ? new Date(toDate) : undefined,
                                                        ]}
                                                        onChange={handleDateChange}
                                                        format="dd/MM/yyyy"
                                                        editable={false}
                                                        placeholder="DD/MM/YYYY - DD/MM/YYYY"
                                                        cleanable={true}
                                                        size="md"
                                                        style={{ width: '100%' }}
                                                        onClean={() => {
                                                            setFromDate('');
                                                            setToDate('');
                                                            setReportrange('');
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                  <div>
                                        <div className="verical-scrl-wrapper common-table sales-ledger-table-scroll" id="style-3">
                                            <table className="table table-bordered dataTable sales-ledger-datatable" id="neworderTable1" ref={salesLedgerRef}>
                                                <thead>
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Type</th>                                                     
                                                        <th>Job Ref</th>
                                                        <th>S.O ID</th>
                                                        <th>Customer (ID)</th>
                                                        <th>Value</th>
                                                        <th>Balance</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                  
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <hr />

                                  {/*     <h5>Aging (i) Requires Customer to be selected from the filter</h5>
                                    <div className="verical-scrl-wrapper common-table" id="style-3">
                                        <table className="table table-bordered dataTable" id="dsTable" >
                                            <thead>
                                                <tr>
                                                    <th>Balance</th>
                                                    <th>UnAlloc</th>
                                                    <th>0 to 1</th>
                                                    <th>1 to 2</th>
                                                    <th>2 to 3</th>
                                                    <th>3 to 4</th>
                                                    <th>4 plus</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>500</td>
                                                    <td>0</td>
                                                    <td>0</td>
                                                    <td>500</td>
                                                    <td>0</td>
                                                    <td>0</td>
                                                    <td>0</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Footer />
        </div>
    );
};

export default SalesList; 
